import React, { useEffect, useState } from "react";

import DefaultScreen from "./defaultScreen";
import { AuthUserContext, withAuthorization } from "../../sessions";

const DefaultScreenContainer = (props) => {
	const [isDebug, setIsDebug] = useState(false);
	let debug;
	const getVersion = () => {
		props.firebase.bd.ref("adminPermission/isDebug").on("value", (snapshot) => {
			debug = snapshot.val();
			setIsDebug(debug);
			localStorage.setItem("isDebug", debug ? debug : false);
		});
	};

	useEffect(() => {
		getVersion();
	}, [isDebug]);

	return (
		<AuthUserContext.Consumer>
			{(authUser) => <DefaultScreen isDebug={isDebug} />}
		</AuthUserContext.Consumer>
	);
};
const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(DefaultScreenContainer);
